import { styled } from '@msdk/ui'
import React, { Component, ErrorInfo, ReactNode } from 'react'

const ErrorContainer = styled('div')`
  width: 100%;
  height: 100%;
  border: 1px solid red;
  background-color: #ff000057;
  text-align: center;
  border-radius: 5px;
  padding: 10px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
`

interface Props {
  children?: ReactNode
}

interface State {
  hasError: boolean
  error?: Error
}

export class ImportedComponentErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    console.error(error, errorInfo)
  }

  public render() {
    if (this.state.hasError) {
      return <ErrorContainer>{this.state.error?.message}</ErrorContainer>
    }

    return this.props.children
  }
}
